import domains from 'app/client/modules/Domains/i18n';
import certificates from 'app/client/modules/Certificates/i18n';
import tickets from 'app/client/modules/Tickets/i18n';
import invoices from 'app/client/modules/Invoices/i18n';

export default {
  namespace: 'search',

  en: {
    title: 'Global search',

    common: {
      placeholder: 'Search…',
      close: 'Close',
      or: 'or',
      search: 'Search',

      tabs: {
        all: 'All',
        domains: 'Domains',
        products: 'Products',
        certificates: 'Certificates',
        tickets: 'Tickets',
        contacts: 'Contacts',
        dns: 'DNS',
        servers: 'Servers',
        apps: 'Apps',
        invoices: 'Invoices',
      },

      footer: {
        globalSearch: 'Global search',
        close: 'Close',
        shortcuts: 'Shortcuts',
        navigate: 'Navigate',

        navigateResults: 'Navigate results',
        navigateTabs: 'Switch tabs',
        open: 'Open',
      },

      shortcuts: {
        open: 'Open search',
        close: 'Close',
      },

      empty: {
        title: 'Start typing to search',
        subtitle: 'Search across domains, tickets, products and more.',
      },

      noResults: {
        title: 'No results',
        subtitle: 'No results found for “{{query}}”.',
      },
    },

    domains: domains.en.common,
    certificates: certificates.en.common,
    tickets: tickets.en.common,
    invoices: invoices.en.common,
    products: {
      active: 'Active',
      cancelled: 'Cancelled',
      cancellationDate: 'Cancelled on',
    },
    apps: {
      healthy: 'Healthy',
      unhealthy: 'Unhealthy',
      unknown: 'Unknown',
    },
    dns: {
      registered: 'Registered',
      unregistered: 'Unregistered',
    },
  },

  nl: {
    title: 'Globaal zoeken',

    common: {
      placeholder: 'Zoeken…',
      close: 'Sluiten',
      or: 'of',
      search: 'Zoeken',

      tabs: {
        all: 'Alles',
        domains: 'Domeinen',
        products: 'Producten',
        certificates: 'Certificaten',
        tickets: 'Tickets',
        contacts: 'Contacten',
        dns: 'DNS',
        servers: 'Servers',
        apps: 'Apps',
        invoices: 'Facturen',
      },

      footer: {
        globalSearch: 'Globaal zoeken',
        close: 'Sluiten',
        shortcuts: 'Sneltoetsen',
        navigate: 'Navigeren',

        navigateResults: 'Resultaten navigeren',
        navigateTabs: 'Tabs wisselen',
        open: 'Openen',
      },

      shortcuts: {
        open: 'Zoeken openen',
        close: 'Sluiten',
      },

      empty: {
        title: 'Begin met typen om te zoeken',
        subtitle: 'Zoek in domeinen, tickets, producten en meer.',
      },

      noResults: {
        title: 'Geen resultaten',
        subtitle: 'Geen resultaten gevonden voor “{{query}}”.',
      },
    },

    domains: domains.nl.common,
    certificates: certificates.nl.common,
    tickets: tickets.nl.common,
    invoices: invoices.nl.common,
    products: {
      active: 'Actief',
      cancelled: 'Geannuleerd',
      cancellationDate: 'Opzegdatum',
    },
    apps: {
      healthy: 'Healty',
      unhealthy: 'Unhealthy',
      unknown: 'Onbekend',
    },
    dns: {
      registered: 'Geregistreerd',
      unregistered: 'Niet geregistreerd',
    },
  },
};
